// 2023-07 functions to parse query params

// 2023-07 - this will be eventually a catalogue
// of parameter names
import {mapValues} from "lodash";

export const KNOWN_PARAMS = {
  APPLE_PAY_ENABLED: "apple-pay",
  DEBUG_PAGE_TRIGGERS: "debugTriggers"
}

function getURLSearchParams(source) {
  const {URLSearchParams} = globalThis;

  if ((typeof source) === 'undefined')
    source = location.search;

  return new URLSearchParams(source);
}

export function getParam(name, defaultValue = null) {
  const usp = getURLSearchParams();
  if (usp.has(name))
    return usp.get(name)
  else
    return defaultValue;
}

export function getParams(source) {
  const usp = getURLSearchParams(source);

  const keys = [...(usp.keys())];

  return _.reduce(keys, (hash, key) => {
    hash[key] = usp.get(key);
    return hash;
  }, {});
}

export function sanelyConvertParams(params) {
  return mapValues(params, (value, key) => {
    // stringifying null gives "null". STUPID!
    if ((value === null) || (typeof value === typeof undefined))
      return "";
    else
      return ''+value;
  })
}

export function paramsToQueryString(params) {
  let cleaned = sanelyConvertParams(params);

  return new URLSearchParams(cleaned).toString();
}
